import { isArray, isPlain } from '../../../utils/xp.v1'
import { laxinBind, laxinMyAwards } from '../../../api/laxin'
import { djMyPrivList } from '../../../api/dianjin'

export default {
  mergeUsers({ state }, users) {
    if (isPlain(users)) {
      state.UserMap = { ...state.UserMap, ...users }
    }
  },

  addUser({ state }, user) {
    if (user && user.id > 0) {
      const UserMap = { ...state.UserMap }
      UserMap[user.id] = { ...user }
      state.UserMap = UserMap
    }
  },
  
  // 我的奖励
  async loadMyAwards({ state, dispatch, getters }) {
    await dispatch('account/readAccount', {}, { root: true })
    if (getters.isValidMobile) {
      const R = await laxinMyAwards()
      state.myAwards = isArray(R.awardList) ? R.awardList : []
      dispatch('laxin/mergeUsers', R.userInfosMap, { root: true })
    }
  },

  async loadPriv({ state, dispatch, getters }) {
    await dispatch('account/readAccount', {}, { root: true })
    if (getters.isValidMobile) {
      const list = await djMyPrivList().then(
        (R) => R.list,
        () => null
      )
      state.myPrivList = list && list.length > 0 ? list : []
    }
  },

  async bind({ getters }, { srcUid, bindType, refId }) {
    const { myUid } = getters
    if (!myUid && srcUid && bindType) {
      await laxinBind({ srcUid, bindType, refId })
    }
  },

  share() {
    const { kStat } = window
    if (kStat && kStat.share) {
      kStat.share()
    }
  }
}
